import { InstitutionEntry } from './InstitutionList';

export class TrackDechetsInfos {
  status: string = '';
  apiKey: string = '';
  missingInstitutions: InstitutionEntry[] = [];
}
